import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const StoreLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const StoreImage = styled.img`
  width: ${props => props.theme.size.S};
  height: ${props => props.theme.size.S};
  object-fit: contain;
  aspect-ratio: 1/1;
`

export const StoreContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`
